import { debounce } from "lodash";
import { useEffect, useState } from "react";

const handleSearch = (searchFunction: () => void) => {
  searchFunction();
};

const handleDebouncedSearch = debounce(handleSearch, 800);

export const useDebounceSearch = ({
  onSearch = () => {},
  searchQuery,
}: {
  onSearch?: (searchQuery?: string | object) => void;
  searchQuery?: string | object;
}) => {
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

  useEffect(() => {
    handleDebouncedSearch(() => {
      if (debouncedQuery !== searchQuery) {
        onSearch(searchQuery);
        setDebouncedQuery(searchQuery);
      }
    });
    // eslint-disable-next-line
  }, [searchQuery]);

  return {
    debouncedQuery,
  };
};
